import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { digitsOnly } from './validation.utils';

export interface PlusgiroErrors {
  invalidPlusgiro?: true;
  invalidPlusgiroMessage?: string;
}

/**
 * Modulus10 / Luhn där kontrollsiffran är sista siffran.
 * Vid validering från höger ska kontrollsiffran INTE dubblas först.
 */
export function isValidPlusgiro(value: string | null | undefined): boolean {
  const digits = digitsOnly(value);

  if (digits.length < 2 || digits.length > 8) {
    return false;
  }

  let sum = 0;
  let shouldDouble = false;

  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = Number(digits.charAt(i));

    if (Number.isNaN(digit)) {
      return false;
    }

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
}

/**
 * Formatterar plusgiro med bindestreck före kontrollsiffran.
 * Ex:
 * 123 -> 12-3
 * 12345678 -> 1234567-8
 */
export function formatPlusgiro(value: string | null | undefined): string {
  const digits = digitsOnly(value);

  if (!digits || digits.length < 2) {
    return digits;
  }

  return `${digits.slice(0, -1)}-${digits.slice(-1)}`;
}

export const plusgiroValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const raw = (control.value ?? '').toString().trim();

  if (!raw) {
    return null;
  }

  const digits = digitsOnly(raw);

  if (digits.length < 2 || digits.length > 8) {
    return {
      invalidPlusgiro: true,
      invalidPlusgiroMessage: 'Kontrollera numret, det brukar ha 2-8 siffror med korrekt kontrollsiffra'
    };
  }

  if (!isValidPlusgiro(digits)) {
    return {
      invalidPlusgiro: true,
      invalidPlusgiroMessage: 'Kontrollera numret, det brukar ha 2-8 siffror med korrekt kontrollsiffra'
    };
  }

  return null;
};